// extracted by mini-css-extract-plugin
export default {"layout":"_5D1-sZ62","content":"_5D1_-eWG"};